// plugins/toastConfirmPlugin.js
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";
// import ConfirmPopup from 'primevue/confirmpopup';
import Dialog from "primevue/dialog";

import { useToastConfirm } from "@shared/composables/useToastConfirm";
import i18n from "@/i18n";
import Modal from "vue-bs-modal";

import BootstrapVueNext from 'bootstrap-vue-next';/*https://bootstrap-vue-next.github.io/bootstrap-vue-next/*/
export default {
  install(app) {
    const toastConfirmInstance = useToastConfirm(i18n);
    app.use(i18n);
    // Gắn các hàm vào globalProperties
    // app.component("ConfirmPopup", ConfirmPopup);
    app.component("Toast", Toast);
    app.component("Dialog", Dialog);
    app.component("ConfirmDialog", ConfirmDialog);
    app.use(Modal)
    app.use(BootstrapVueNext)
   
    
    app.config.globalProperties.$showToast = toastConfirmInstance.showToast;
    app.config.globalProperties.$showConfirm = toastConfirmInstance.showConfirm;
    // app.config.globalProperties.$showConfirmPopup = toastConfirmInstance.showConfirmPopup;
  },
};
